export const PageDetails = {
  'monarch-mind': {
    id: 'monarch-mind',
    title: 'Monarch Mind',
    url: 'monarch-mind',
    logo: '/img/monarchMind.svg',
  },
  gemini: {
    id: 'gemini',
    page: 'gemini',
    title: 'Gemini',
    icon: '/img/google-gemini-icon.svg.png',
    externalUrl: 'https://gemini.google.com/app',
    description: (
      <div>
        MonarchMind is being reimagined into a home-base app for multiple AI functionalities within
        the ODU online infrastructure. To access the old MonarchMind functionality of a secure,
        University-centered large language model, access Google Gemini through the link below.{' '}
        <b>When accessing Gemini, ensure you are logged into Google using your ODU credentials.</b>{' '}
        This will maintain a secure, Old Dominion University-focused interaction.
      </div>
    ),
    cardClass: 'gemini',
  },
  esga: {
    id: 'esga',
    page: 'esga',
    title: 'ODU Editorial Style Guide Assistant',
    icon: '/img/esga.svg',
    description:
      'Upload documents to be analyzed against the specific rules of the official ODU Style Guide.  The system generates a report highlighting non-adherence and offering corrections.',
    cardClass: 'esga',
  },
  notebookLM: {
    id: 'notebookLM',
    page: 'notebookLM',
    title: 'NotebookLM',
    icon: '/img/notebookLM.svg',
    externalUrl: 'https://notebooklm.google.com/',
    description: (
      <div>
        NotebookLM is an AI-powered research and note-taking application created by Google. It is
        designed to assist users in summarizing, analyzing, and synthesizing information from their
        documents. Built on Google Gemini models, it is a personalized, source-grounded tool that
        limits its responses to user-provided content.{' '}
        <b>
          To access a secure, University-centered NotebookLM experience, users should log into
          NotebookLM using ODU credentials.
        </b>
      </div>
    ),
    cardClass: 'notebookLM',
  },
};
